import JsBarcode from "jsbarcode";
import { TDocumentDefinitions } from "pdfmake/interfaces";

import { rotateImage, textToBase64BarcodeBlob } from "./FormMedicine";

// Types
export type HeaderMedicineMoreProps = {
  hn: number;
  patient: string;
  birthdate?: string;
  type: string;
  full_age?: string;
  code: string;
  requested: Record<string, any> | null;
  page: string;
  key_user?: string;
  ip_address?: string;
};

const HeaderMedicineMore = async (
  props: HeaderMedicineMoreProps
): Promise<TDocumentDefinitions> => {
  const rotatedBarcode = await rotateImage(textToBase64BarcodeBlob(props.code), 90);

  return {
    pageSize: "A5",
    pageMargins: [15, 65, 30, 55],
    pageOrientation: "landscape",
    defaultStyle: {
      font: "THSarabunNew",
      lineHeight: 1,
      fontSize: 14,
    },
    header: () => {
      return {
        margin: [20, 10, 5, 0],
        columns: [
          {
            width: "76.25%",
            stack: [
              {
                columns: [
                  {
                    width: "46%",
                    stack: [
                      {
                        text: `${props.patient} HN: ${props.hn}`,
                        bold: true,
                        marginTop: 10,
                      },
                      {
                        text: [
                          { text: "ว/ด/ป เกิด: ", bold: true, fontSize: 13 },
                          {
                            text: `${props.birthdate || "-"} อายุ ${props.full_age || "-"}`,
                            fontSize: 13,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    width: "54%",
                    text: "",
                  },
                ],
              },
              {
                margin: [20, -20, 20, 0],
                columns: [
                  {
                    width: "46%",
                    text: "",
                  },
                  { text: "", width: "1%" },
                  {
                    width: "53%",
                    marginTop: 7.5,
                    stack: [
                      {
                        text: "",
                        bold: true,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            width: "*",
            stack: [
              {
                text: `Page ${props.page}`,
                alignment: "right",
                fontSize: 13,
                margin: [0, -2.5, 15, 0],
              },
              // {
              //   image: textToBase64BarcodeBlob(props.code),
              //   width: 80,
              //   height: 12.5,
              //   border: [false, false, false, false],
              //   alignment: "right",
              //   margin: [0, 0, 5, 2.5],
              // },
              {
                table: {
                  widths: [50, 50],
                  heights: [18],
                  body: [
                    [
                      {
                        text: props.type.replace("_", ""),
                        fillColor: "#000000",
                        color: "white",
                        alignment: "center",
                        fontSize: 13,
                      },
                      {
                        text: props.code,
                        alignment: "center",
                        fontSize: 13,
                      },
                    ],
                  ],
                },
                layout: {
                  paddingTop: () => {
                    return 0;
                  },
                  paddingBottom: () => {
                    return 0;
                  },
                  paddingLeft: () => {
                    return 5;
                  },
                  paddingRight: () => {
                    return 5;
                  },
                  hLineWidth: () => {
                    return 0.5;
                  },
                  vLineWidth: () => {
                    return 0.5;
                  },
                },
              },
            ],
          },
        ],
      };
    },
    footer: () => {
      return {
        stack: [
          {
            margin: [15, 0, 30, 0],
            table: {
              widths: ["25%", "25%", "25%", "25%"],
              body: [
                [
                  {
                    style: "tableData",
                    text: `แพทย์: ${props.requested?.name || ""}`,
                  },
                  { style: "tableData", text: "ผู้จัดยา" },
                  { style: "tableData", text: "เภสัชกร1" },
                  { style: "tableData", text: "Tel" },
                ],
                [
                  // { style: "tableData", text: "\u00A0" },
                  { style: "tableData", text: `ผู้คีย์: ${props.key_user || ""}` },
                  { style: "tableData", text: "Pre-check" },
                  { style: "tableData", text: "เภสัชกร2" },
                  { style: "tableData", text: `IP: ${props.ip_address || ""}` },
                ],
              ],
            },
            layout: {
              hLineWidth: () => {
                return 0.5;
              },
              vLineWidth: () => {
                return 0.5;
              },
            },
          },
          {
            // border: [false, false, false, false],
            height: 120,
            image: rotatedBarcode,
            // margin: [-12.5, 2, 0, 3],
            absolutePosition: { x: 567, y: -126 },
            width: 25,
          },
        ],
      };
    },
    images: {},
  };
};

export default HeaderMedicineMore;
